/** localStorage key for theme preference. */
export const THEME_STORAGE_KEY = 'evplanner-theme';

/** @typedef {'light' | 'dark' | 'system'} ThemePreference */

/** @type {ThemePreference[]} */
export const THEME_OPTIONS = ['light', 'dark', 'system'];

/**
 * @param {string | null | undefined} value
 * @returns {ThemePreference}
 */
export function parseThemePreference(value) {
  if (value === 'light' || value === 'dark' || value === 'system') {
    return value;
  }
  return 'system';
}

/**
 * Resolve whether dark mode should be active.
 * @param {ThemePreference} preference
 * @returns {boolean}
 */
export function resolveDarkMode(preference) {
  if (preference === 'dark') return true;
  if (preference === 'light') return false;
  if (typeof window !== 'undefined' && window.matchMedia) {
    return window.matchMedia('(prefers-color-scheme: dark)').matches;
  }
  return false;
}

/**
 * Apply or remove the `dark` class on the document root.
 * @param {ThemePreference} preference
 */
export function applyThemeClass(preference) {
  if (typeof document === 'undefined') return;
  document.documentElement.classList.toggle('dark', resolveDarkMode(preference));
}

/**
 * Read stored theme preference from localStorage.
 * @returns {ThemePreference}
 */
export function readStoredTheme() {
  try {
    return parseThemePreference(localStorage.getItem(THEME_STORAGE_KEY));
  } catch {
    return 'system';
  }
}

/**
 * Persist theme preference.
 * @param {ThemePreference} preference
 */
export function writeStoredTheme(preference) {
  try {
    localStorage.setItem(THEME_STORAGE_KEY, preference);
  } catch {
    /* ignore quota / private mode */
  }
}
